/** Helpers sélection tactile envoi cuisine POS restaurant */

export function panierLinePrepSent(l) {
  const st = l?.prepLineStatus || l?.posPrepLine?.status;
  return Boolean(st && st !== 'CANCELLED');
}

export function panierLineNeedsKitchenSend(l) {
  if (panierLinePrepSent(l)) return false;
  if (l?.requiresPreparation === false) return false;
  if (l?.produit?.requiresPreparation === false) return false;
  return true;
}

export function isPanierLineSelectedForPrepSend(l) {
  if (!panierLineNeedsKitchenSend(l)) return false;
  if (l.prepSelectedForSend === false) return false;
  return true;
}

export function prepReleaseIntentFromPanierLine(l) {
  if (!panierLineNeedsKitchenSend(l)) return 'NOW';
  return l.prepSelectedForSend === false ? 'DEFER' : 'NOW';
}

/** Compte les lignes (1 ligne = 1, pas la quantité — cohérent avec le KDS actuel) */
export function countPanierLinesForPrepSend(panier, { selectedOnly = false, allPending = false } = {}) {
  let n = 0;
  for (const l of panier || []) {
    if (!panierLineNeedsKitchenSend(l)) continue;
    if (selectedOnly && !isPanierLineSelectedForPrepSend(l)) continue;
    if (!selectedOnly && !allPending && l.prepSelectedForSend === false) continue;
    n += 1;
  }
  return n;
}

export function selectedCommandeProduitIdsForSend(panier) {
  return (panier || [])
    .filter((l) => isPanierLineSelectedForPrepSend(l) && l.commandeProduitId)
    .map((l) => l.commandeProduitId);
}

export function ticketLinePrepActive(prepLine) {
  return Boolean(prepLine && prepLine.status !== 'CANCELLED');
}

export function ticketLineNeedsKitchenSend(line, prepLine) {
  if (ticketLinePrepActive(prepLine)) return false;
  const needsPrep = line?.requiresPreparation ?? line?.produit?.requiresPreparation;
  if (needsPrep === false) return false;
  if (line?.indisponibleAt) return false;
  const stationId = line?.preparationStationId ?? line?.produit?.preparationStationId;
  return Boolean(stationId);
}

export function countTicketLinesForKitchenSend(produits, prepById, { selectedOnly = false, allPending = false } = {}) {
  let n = 0;
  for (const l of produits || []) {
    const prep = prepById?.get?.(l.id);
    if (!ticketLineNeedsKitchenSend(l, prep)) continue;
    const selected = l.prepReleaseIntent !== 'DEFER';
    if (selectedOnly && !selected) continue;
    if (!selectedOnly && !allPending && !selected) continue;
    n += 1;
  }
  return n;
}

export function countSelectedPendingKitchenLines(produits, prepById, selectedIds) {
  let n = 0;
  for (const l of produits || []) {
    const prep = prepById?.get?.(l.id);
    if (!ticketLineNeedsKitchenSend(l, prep)) continue;
    if (selectedIds?.has?.(l.id)) n += 1;
  }
  return n;
}

export function countAllPendingKitchenLines(produits, prepById) {
  let n = 0;
  for (const l of produits || []) {
    const prep = prepById?.get?.(l.id);
    if (ticketLineNeedsKitchenSend(l, prep)) n += 1;
  }
  return n;
}

export function buildPrepIntentsFromSelection(produits, prepById, selectedIds) {
  const intents = [];
  for (const l of produits || []) {
    const prep = prepById?.get?.(l.id);
    if (!ticketLineNeedsKitchenSend(l, prep)) continue;
    intents.push({
      commandeProduitId: l.id,
      prepReleaseIntent: selectedIds.has(l.id) ? 'NOW' : 'DEFER',
    });
  }
  return intents;
}

export function hydratePrepSelectionFromTicketLine(lp) {
  const prepLine = lp?.posPrepLine;
  const sent = prepLine && prepLine.status !== 'CANCELLED';
  const intent = lp?.prepReleaseIntent === 'DEFER' ? 'DEFER' : 'NOW';
  return {
    prepLineStatus: prepLine?.status || null,
    prepSelectedForSend: sent ? false : intent !== 'DEFER',
    requiresPreparation: lp?.produit?.requiresPreparation,
    preparationStationId: lp?.produit?.preparationStationId,
  };
}
